<template>
  <div class="field" v-if="!isEmpty" :key="displayField.name">
    <template v-if="showLibraryStyle">
      <!-- Bio V4 design -->
      <label
        :for="formattedField"
        class="bio-b4-class field-label"
        :data-test="label"
        aria-live="polite"
      >
        {{ label }}
      </label>
      <div class="bio-b4-class field-item">
        <!-- If there is vHtml in data -->
        <div
          v-if="vHtmlIsSet"
          v-html="computedHtml"
          data-test="computedHtml"
          class="computed-html-item"
          aria-live="polite"
          :aria-label="computedHtml"
        />
        <!-- If formattedField > 20 characters then use textarea -->
        <textarea
          v-else-if="isformattedFieldLengthTooLong"
          :value="formattedField"
          :name="formattedField"
          :rows="textareaHeight"
          :data-test="formattedField"
          disabled
          aria-readonly="true"
          :id="formattedField"
          aria-live="polite"
          :aria-label="formattedField"
        />
        <!-- Otherwise use input -->
        <input
          v-else
          type="text"
          :value="formattedField"
          :name="formattedField"
          :data-test="formattedField"
          disabled
          aria-readonly="true"
          :id="formattedField"
          aria-live="polite"
          :aria-label="formattedField"
        />
        <div
          class="book-vector"
          v-if="showLibraryStyle"
          data-test="book-vector"
        >
          <img :src="vectorSrc" alt="material is copied from library" />
          <div class="book-tooltip">
            <img
              :src="toolTipSrc"
              class="book-tooltip-img"
              alt="tooltip: material copied from library"
            />
            <div class="book-tooltip-text" aria-readonly="true">
              From Library
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Other design for non-bio pages -->
    <template v-else>
      <div class="field-label field__label" :class="labelClass">
        {{ label }}:
      </div>
      <div
        v-if="vHtmlIsSet"
        v-html="computedHtml"
        class="field-item field__item"
      />
      <div v-else class="field-item field__item" :class="itemClass">
        {{ formattedField }}
      </div>
    </template>
  </div>
</template>

<script>
import vector from "@/images/Vector.svg";
import tooltip from "@/images/B4Tooltip.svg";
import RaftGenericHelper from "../../lib/raft_generic_helper";

// @todo: Rename component, props per https://bitbucket.org/raftdev/%7B81a1a301-c029-4f9e-ad45-100b96525214%7D/pull-requests/1386 for RAFT-4851
export default {
  name: "FieldDisplay",
  props: {
    displayField: {
      type: Object,
      required: true,
    },
    hideEmpty: {
      type: Boolean,
      default: false,
    },
    individualFieldData: {
      required: true,
    },
    itemClass: {
      type: String,
      default: "raft-js-bio-mat-item",
    },
    labelClass: {
      type: String,
      default: "raft-js-bio-mat-label",
    },
    showLibraryStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bioClass: "",
      vectorSrc: vector,
      toolTipSrc: tooltip,
    };
  },
  computed: {
    computedHtml() {
      return this.vHtmlIsSet ? this.formattedField?.v_html : null;
    },
    isEmpty() {
      if (this.hideEmpty) {
        if (typeof this.individualFieldData === "object") {
          return RaftGenericHelper.isNotEmpty(this.individualFieldData);
        }
        return (
          this.formattedField === "" ||
          typeof this.formattedField === "undefined"
        );
      }
      return false;
    },
    label() {
      return this.displayField?.label;
    },
    formattedField() {
      if (typeof this.displayField?.formatted === "string") {
        return this.displayField?.formatted.trim();
      }
      return this.displayField?.formatted;
    },
    vHtmlIsSet() {
      return (
        !!this.formattedField &&
        this.formattedField.hasOwnProperty("v_html") &&
        typeof this.formattedField?.v_html !== "undefined"
      );
    },
    isformattedFieldLengthTooLong() {
      // 44 is the length of characters before it gets cut off based on field width 21.875rem
      return this.formattedField?.length > 44;
    },
    textareaHeight() {
      if (this.formattedField) {
        return Math.ceil(this.formattedField.length / 44);
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.raft-js-bio-mat-item {
  display: inline-block;
}

.raft-js-bio-mat-label {
  display: inline-block;
}

.bio-b4-class.field-label {
  display: inline-block;
}

.bio-b4-class.field-item {
  padding: 0.3em 0.25em;
  background: var(--gray-100);
  width: 21.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.25em;
}
#raft-js > div > div > div > div > textarea,
#material-details > p > div > div > div > textarea {
  border: none;
  width: 100%;
  font-size: var(--font-size-75);
  background: var(--gray-100);
  resize: none;
  overflow: hidden;
  font-family: var(--font-system-ui);
}
#raft-js > div > div > div > div > input[type="text"],
#material-details > p > div > div > div > input[type="text"] {
  border: none;
  width: 100%;
  font-size: var(--font-size-75);
  background: var(--gray-100);
  font-family: var(--font-system-ui);
}
.book-vector {
  position: relative;
}
.book-vector:hover .book-tooltip {
  visibility: visible;
}
.book-tooltip {
  visibility: hidden;
  position: absolute;
  top: -12px;
  left: 16px;
}
.book-tooltip-img {
  position: relative;
}
.book-tooltip-text {
  position: absolute;
  top: 12px;
  left: 18px;
  font-size: var(--font-size-75);
  font-weight: normal;
}
</style>
